/**
 * @requires ./frc.js
 */

frc.modules.instagramFeed = function(){
	var self = this;
	
	self.data = {
		"feed": null
	};

	self.init = function() {
		// Juicer.io IG Feed direct workaround
		// const IG_BASE_URL = "https://www.juicer.io/api/feeds/eatnorthitalia";
		// $.ajax({
		// 	url: IG_BASE_URL, 
		// 	success: function(result) {
		// 		console.log(result.posts.items);
		// 		const images = result.posts.items
				
		// 		function setImage(img) {
		// 			return `<a href="${img.full_url}" target="_blank" class="instagram-item"></a>`;
		// 		}

		// 		const selectedImages = [
		// 			images[1],
		// 			images[2],
		// 			images[3],
		// 			images[4],
		// 			images[5],
		// 		];
		// 		// Set static images
		// 		selectedImages.forEach((item, index) => {
		// 			let $imgElement = $(setImage(item));
		// 			$imgElement.css('background-image', `url("${item.image}")`);

		// 			$domElement = $(`.instagram-posts li:nth-of-type(${index+1}) .instagram-switcher`);
		// 			// Add the existing img <a href> tag to dom, then append bg image 
		// 			$domElement.html($imgElement);
		// 		});
		// 	}
		// });
		
		const handlebarsHtmlTemplate = 
			'<a class="instagram-item" href="{{permalink}}" target="_blank" data-permalink="{{permalink}}" ' + 
			'alt="{{#if caption}}{{caption}}{{else}}@{{username}} on Instagram{{/if}}">' + 
				'<img src="{{media_url}}" data-src="{{media_url}}">' + 
			'</a>';


		self.data.feed = new Insta({
			name: 'InstagramFeedS',
			brand_id: frcContext.brand.id,
			template: handlebarsHtmlTemplate,
			onInit: function() {
				// Grab posts in batches of 4 at a time
				$('.instagram-posts li:nth-of-type(4) .instagram-switcher').html(
					self.data.feed.Posts(0,4, true)
				);
				$('.instagram-posts li:nth-of-type(5) .instagram-switcher').html(
					self.data.feed.Posts(4,4, true)
				);
				$('.instagram-posts li:nth-of-type(1) .instagram-switcher').html(
					self.data.feed.Posts(8,4, true)
				);
				$('.instagram-posts li:nth-of-type(2) .instagram-switcher').html(
					self.data.feed.Posts(12,4, true)
				);

				var instaOne = new instaSlide('.instagram-posts li:nth-of-type(1) .instagram-switcher', 
					{timing: 10000, paused: false, delay: 3000, transition: 2000}
				);
				var instaTwo = new instaSlide('.instagram-posts li:nth-of-type(2) .instagram-switcher', 
					{timing: 10000, paused: false, delay: 1500, transition: 2000}
				);
				var instaThree = new instaSlide('.instagram-posts li:nth-of-type(4) .instagram-switcher', 
					{timing: 10000, paused: false, transition: 2000}
				);
				var instaFour = new instaSlide('.instagram-posts li:nth-of-type(5) .instagram-switcher', 
					{timing: 10000, paused: false, delay: 4500, transition: 2000}
				);
			}
		});
	};
	return self;
};